export default __webpack_public_path__ + "asset/spain.300bbe7e41d8625086d5bbab837bf6ba.svg";